import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import KitchenLayout from '../layouts/KitchenLayout';
import { useAuth } from '../contexts/AuthContext';
import AuthGuard from '../contexts/AuthGuard';

// Kitchen Pages
const Dashboard = lazy(() => import('../pages/modules/kitchen/dashboard/Dashboard'));
const KitchenDisplay = lazy(() => import('../pages/modules/kitchen/display/KitchenDisplay'));
const OrderHistory = lazy(() => import('../pages/modules/kitchen/order-history/OrderHistory'));
const Reports = lazy(() => import('../pages/modules/kitchen/reports/Reports'));
const OrderList = lazy(() => import('../pages/modules/restaurant/orders/OrderList/OrderList'));

const RouteFallback = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
    <div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div>
  </div>
);

const KitchenRoutes = () => {
  const { logout } = useAuth();

  return (
    <AuthGuard>
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route element={<KitchenLayout onLogout={logout} />}>
            <Route path="/" element={<Navigate to="/kitchen/dashboard" replace />} />
            <Route path="/kitchen" element={<Navigate to="/kitchen/dashboard" replace />} />

            {/* Kitchen Module Routes */}
            <Route path="/kitchen/dashboard" element={<Dashboard />} />
            <Route path="/kitchen/display" element={<OrderList />} />
            <Route path="/kitchen/orders/list" element={<OrderList />} />
            <Route path="/kitchen/order-history" element={<OrderHistory />} />
            <Route path="/kitchen/reports" element={<Reports />} />

            <Route path="*" element={<Navigate to="/kitchen/dashboard" replace />} />
          </Route>
        </Routes>
      </Suspense>
    </AuthGuard>
  );
};

export default KitchenRoutes;
